import { AppBar, Avatar, Box, Grid, Hidden, Icon, IconButton, Theme, ThemeProvider, Toolbar, createTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ORANGE_COLOR, PRIMARY_COLOR, SECONDARY_COLOR } from "../../_const/color.const";
import { Facebook, Instagram, Twitter, YouTube, Logout } from "@mui/icons-material";
import { accountService } from "../../_services/accounts.service";
import { getInitials } from "../../_helpers/format.helper";


const logoImg = require('../../_assets/images/Logo-Blue-Background.png');

const drawerWidth = 240;

const appBarSx = (theme: Theme) => ({
    flexGrow: 1,
    backgroundColor: PRIMARY_COLOR[0],
    boxShadow: 'none',
})

const contentShiftSx = (theme: Theme) => ({
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
})

const pageHeadingSx = (theme: Theme) => ({
    color: "white",
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
    "& h6": {
        margin: "0px",
        padding: "0px",
        marginTop: "14px",
        fontWeight: "bold"
    },
    "& div": {
        color: "white"
    },
    "& label": {
        color: "white",
    },
    "& svg": {
        color: "white"
    },
    "& input": {
        color: "white"
    },
    '& label.Mui-focused': {
        color: 'white',
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: 'white',
    },
    "&>div>div>div>div": {
        borderBottom: "1px solid white"
    },
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: 'white',
        },
        '&:hover fieldset': {
            borderColor: 'white',
        },
        '&.Mui-focused fieldset': {
            borderColor: 'white',
        },
    },
})

const theme = createTheme({
    palette: {
        primary: {
            main: PRIMARY_COLOR[0],
        },
        secondary: {
            main: SECONDARY_COLOR
        }
    },
    typography: {
        fontFamily: "Montserrat",
        h3: {
            fontFamily: "Montserrat",
            color: "#444",
            letterSpacing: "0.0075em",
            verticalAlign: "middle",
        },
        h5: {
            width: "100%",
            margin: "10px",
            marginTop: "20px",
            borderBottom: "1px solid silver"
        },
        h6: {
            fontFamily: "Montserrat",
            color: "#444",
            letterSpacing: "0.0075em",
            verticalAlign: "middle",
            marginTop: "20px"
        }
    }
});


export const AppToolbar = (params: { toggleSidebar: () => void, isOpen: boolean }) => {

    const [isOpen, setIsOpen] = useState(params.isOpen);
    const navigate = useNavigate();
    useEffect(() => {
        setIsOpen(params.isOpen);
    }, [params.isOpen]);

    return (
        <AppBar position="fixed" sx={appBarSx}>

            <ThemeProvider theme={theme}>
            </ThemeProvider>

            <Toolbar>
                <Grid container style={{ margin: "16px", marginBottom: "0px" }}>
                    <Grid item xs={4}>
                        <Box>
                            <img
                                alt="Motorsport Logo"
                                style={{
                                    width: "auto",
                                    marginTop: "-10px",
                                    display: 'block',
                                    marginLeft: '0px',
                                    marginRight: 'auto',
                                    height: "56px",
                                    float: "left"
                                }} src={logoImg}></img>
                            <span style={{ fontSize: "32px", float: "left", marginLeft: "20px" }}></span>
                        </Box>
                    </Grid>

                    <Grid item xs={8}>
                        {(!accountService.isAdmin) &&

                            <Grid container justifyContent="flex-end">
                                <Grid item xs={5}>

                                </Grid>
                                <Grid item xs={7}>

                                    <IconButton
                                        title="Log Out"
                                        sx={{ marginLeft: "16px" }}
                                        color="inherit"
                                        aria-label="logout"
                                        style={{ "float": "right" }}
                                        onClick={accountService.logout}
                                    >
                                        <Logout />
                                    </IconButton>

                                    <Hidden mdDown>

                                        <IconButton
                                            color="inherit"
                                            aria-label="facebook"
                                            href="https://www.facebook.com/MotorsportIreland/"
                                            style={{ "float": "right" }}
                                            target="_blank">
                                            <Facebook />
                                        </IconButton>

                                        <IconButton
                                            color="inherit"
                                            aria-label="instagram"
                                            style={{ "float": "right" }}
                                            href="https://www.instagram.com/motorsportirl/"
                                            target="_blank">
                                            <Instagram />
                                        </IconButton>

                                        <IconButton
                                            color="inherit"
                                            aria-label="twitter"
                                            href="https://x.com/MotorsportIRL"
                                            style={{ "float": "right" }}
                                            target="_blank">
                                            <Twitter />
                                        </IconButton>

                                        <IconButton
                                            color="inherit"
                                            aria-label="youtube"
                                            style={{ "float": "right" }}
                                            href="https://www.youtube.com/channel/UCgmeuqOA6d-IUtT3O-aQE8g"
                                            target="_blank">
                                            <YouTube />
                                        </IconButton>

                                    </Hidden>
                                    <Hidden mdUp>
                                        <IconButton
                                            color="inherit"
                                            aria-label="menu"
                                            style={{ "float": "right" }}
                                            onClick={(e) => { params.toggleSidebar() }}>
                                            <Icon>menu</Icon>
                                        </IconButton>
                                    </Hidden>

                                </Grid>
                            </Grid>
                        }

                        {(accountService.isAdmin) &&

                            <Grid container justifyContent="flex-end">
                                <Grid item xs={5}>

                                </Grid>
                                <Grid item xs={7}>

                                    <IconButton
                                        title="Log Out"
                                        sx={{ marginLeft: "16px" }}
                                        color="inherit"
                                        aria-label="logout"
                                        style={{ "float": "right" }}
                                        onClick={accountService.logout}
                                    >
                                        <Logout />
                                    </IconButton>

                                    <Hidden mdDown>

                                        <Box display={{ xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' }}
                                            sx={{
                                                position: "relative",
                                                float: "right",
                                                height: "100%",
                                                cursor: "pointer",
                                            }}
                                        >
                                            <Avatar
                                                sx={{
                                                    bgcolor: ORANGE_COLOR,
                                                    width: "40px",
                                                    height: "40px",
                                                    fontSize: "22px",
                                                    margin: "0px",
                                                    border: "0px !important",
                                                    marginRight: "35px",
                                                    color: "white",
                                                }}>
                                                {getInitials(accountService.currentUserValue.name || accountService.currentUserValue.email)}
                                            </Avatar>

                                        </Box>

                                        <Box display={{ xs: 'none', sm: 'none', md: 'block', lg: 'block', xl: 'block' }}
                                            sx={{
                                                padding: "12px 12px 12px 12px",
                                                float: "right",
                                                fontSize: "16px",
                                                cursor: "pointer",
                                                color: "white",
                                            }}
                                        >
                                            {accountService.currentUserValue?.name}
                                        </Box>

                                    </Hidden>
                                    <Hidden mdUp>
                                        <IconButton
                                            color="inherit"
                                            aria-label="menu"
                                            style={{ "float": "right" }}
                                            onClick={(e) => { params.toggleSidebar() }}>
                                            <Icon>menu</Icon>
                                        </IconButton>
                                    </Hidden>

                                </Grid>
                            </Grid>
                        }

                    </Grid>

                </Grid>
            </Toolbar>
        </AppBar >
    );
};